import { render, staticRenderFns } from "./GetSourceMessage.vue?vue&type=template&id=503e7d3d&scoped=true"
import script from "./GetSourceMessage.vue?vue&type=script&lang=js"
export * from "./GetSourceMessage.vue?vue&type=script&lang=js"
import style0 from "./GetSourceMessage.vue?vue&type=style&index=0&id=503e7d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e7d3d",
  null
  
)

export default component.exports